import { Route } from 'react-router-dom';
import { ChildList } from './list';
import { ChildShow } from './show';

export const ChildrenRoute = (
  <Route path="children">
    <Route index element={<ChildList />} />
    <Route path=":id" element={<ChildShow />} />
  </Route>
);
